(function () {
    'use strict';
    
    /**
     * Contrôleur pour afficher le détail d'une discussion de forum
     */
    angular.module('observatoireApp')
        .controller('ForumDetailController', ForumDetailController);
    
    ForumDetailController.$inject = ['$scope', '$state', '$stateParams', 'ForumApiService', 'BudgetApiService', 'AuthService', 'toaster'];
    
    function ForumDetailController($scope, $state, $stateParams, ForumApiService, BudgetApiService, AuthService, toaster) {
        var vm = this;
        
        // Variables
        vm.discussion = null;
        vm.editedDiscussion = null;
        vm.jeuxDonnees = [];
        vm.isLoading = true;
        vm.formSubmitted = false;
        vm.editMode = false;
        vm.isAdmin = AuthService.isAdmin();
        
        // Variables pour les réponses
        vm.reponses = [];
        vm.isLoadingReponses = false;
        vm.newReponse = {};
        vm.reponseFormSubmitted = false;
        
        // Fonctions
        vm.loadDiscussion = loadDiscussion;
        vm.loadJeuxDonnees = loadJeuxDonnees;
        vm.updateDiscussion = updateDiscussion;
        vm.deleteDiscussion = deleteDiscussion;
        vm.showEditForm = showEditForm;
        vm.cancelEdit = cancelEdit;
        
        // Fonctions pour les réponses
        vm.loadReponses = loadReponses;
        vm.addReponse = addReponse;
        vm.deleteReponse = deleteReponse;
        
        // Initialisation
        init();
        
        function init() {
            loadJeuxDonnees();
            
            if ($stateParams.id) {
                loadDiscussion($stateParams.id);
            } else {
                vm.isLoading = false;
                toaster.pop('error', 'Erreur', 'ID de discussion non spécifié');
                $state.go('budget.forum');
            }
        }
        
        /**
         * Charge une discussion par son ID
         * @param {Number} id ID de la discussion
         */
        function loadDiscussion(id) {
            vm.isLoading = true;
            ForumApiService.getDiscussionById(id)
                .then(function (data) {
                    vm.discussion = data;
                    vm.isLoading = false;
                    // Chargement automatique des réponses après le chargement de la discussion
                    loadReponses(id);
                })
                .catch(function (error) {
                    vm.isLoading = false;
                    toaster.pop('error', 'Erreur', 'Impossible de charger les détails de la discussion');
                });
        }
        
        /**
         * Charge la liste des jeux de données
         */
        function loadJeuxDonnees() {
            BudgetApiService.getAllJeuxDonnees()
                .then(function (data) {
                    vm.jeuxDonnees = data;
                })
                .catch(function (error) {
                    toaster.pop('error', 'Erreur', 'Impossible de charger les jeux de données');
                });
        }
        
        /**
         * Met à jour une discussion
         */
        function updateDiscussion() {
            vm.formSubmitted = true;
            
            if (!vm.editedDiscussion.titre || !vm.editedDiscussion.contenu || !vm.editedDiscussion.jeuDonneesCode) {
                toaster.pop('warning', 'Attention', 'Veuillez remplir tous les champs obligatoires');
                return;
            }
            
            ForumApiService.updateDiscussion(vm.discussion.id, vm.editedDiscussion)
                .then(function (data) {
                    toaster.pop('success', 'Succès', 'La discussion a été mise à jour avec succès');
                    vm.discussion = data;
                    vm.editMode = false;
                    vm.formSubmitted = false;
                })
                .catch(function (error) {
                    toaster.pop('error', 'Erreur', 'Impossible de mettre à jour la discussion');
                });
        }
        
        /**
         * Supprime une discussion
         * @param {Number} id ID de la discussion à supprimer
         */
        function deleteDiscussion(id) {
            if (confirm('Êtes-vous sûr de vouloir supprimer cette discussion ?')) {
                ForumApiService.deleteDiscussion(id)
                    .then(function () {
                        toaster.pop('success', 'Succès', 'Discussion supprimée avec succès');
                        $state.go('budget.forum');
                    })
                    .catch(function (error) {
                        toaster.pop('error', 'Erreur', 'Impossible de supprimer la discussion');
                    });
            }
        }
        
        /**
         * Affiche le formulaire d'édition
         */
        function showEditForm() {
            vm.editedDiscussion = angular.copy(vm.discussion);
            vm.editMode = true;
            vm.formSubmitted = false;
        }
        
        /**
         * Annule l'édition de la discussion
         */
        function cancelEdit() {
            vm.editMode = false;
            vm.formSubmitted = false;
        }
        
        /**
         * Charge les réponses d'une discussion
         * @param {Number} discussionId ID de la discussion
         */
        function loadReponses(discussionId) {
            vm.isLoadingReponses = true;
            ForumApiService.getReponsesByDiscussionId(discussionId)
                .then(function(data) {
                    vm.reponses = data;
                    vm.isLoadingReponses = false;
                })
                .catch(function(error) {
                    vm.isLoadingReponses = false;
                    console.error('Erreur lors du chargement des réponses:', error);
                    toaster.pop('error', 'Erreur', 'Impossible de charger les réponses');
                });
        }
        
        /**
         * Ajoute une nouvelle réponse à la discussion
         */
        function addReponse() {
            vm.reponseFormSubmitted = true;
            
            if (!vm.newReponse.contenu || !vm.newReponse.auteur) {
                toaster.pop('warning', 'Attention', 'Veuillez remplir tous les champs obligatoires');
                return;
            }
            
            // Préparer la nouvelle réponse
            var reponse = angular.copy(vm.newReponse);
            reponse.discussionId = vm.discussion.id;
            
            ForumApiService.createReponse(reponse)
                .then(function(data) {
                    toaster.pop('success', 'Succès', 'Votre réponse a été ajoutée avec succès');
                    vm.reponses.push(data);
                    // Réinitialiser le formulaire
                    vm.newReponse = {};
                    vm.reponseFormSubmitted = false;
                })
                .catch(function(error) {
                    console.error('Erreur lors de l\'ajout de la réponse:', error);
                    toaster.pop('error', 'Erreur', 'Impossible d\'ajouter votre réponse');
                });
        }
        
        /**
         * Supprime une réponse
         * @param {Number} id ID de la réponse à supprimer
         */
        function deleteReponse(id) {
            if (confirm('Êtes-vous sûr de vouloir supprimer cette réponse ?')) {
                ForumApiService.deleteReponse(id)
                    .then(function() {
                        toaster.pop('success', 'Succès', 'Réponse supprimée avec succès');
                        // Mettre à jour la liste des réponses
                        vm.reponses = vm.reponses.filter(function(reponse) {
                            return reponse.id !== id;
                        });
                    })
                    .catch(function(error) {
                        console.error('Erreur lors de la suppression de la réponse:', error);
                        toaster.pop('error', 'Erreur', 'Impossible de supprimer la réponse');
                    });
            }
        }
    }
})();
